import React, { useEffect } from "react";
import "../../../../../src/cityspark/index.v1.0.23.css"; // 👈 add this
import Cookies from "js-cookie";

function CitySparkHeader(props) {
  const { disableNavBarAndTopBar } = props;
  useEffect(() => {
    const script = document.createElement("script");
    script.src = process.env.PUBLIC_URL + "/header.umd.v1.0.25.js";
    script.async = true;

    script.onload = () => {
      if (!window.CitySparkHeader || !window.CitySparkHeader.mountWidget) {
        console.error("CitySparkHeader or mountWidget is not available");
        return;
      }

      let oidcUser = localStorage.getItem("oidcUser");
      let formatedOutput = JSON.parse(oidcUser);
      let name = formatedOutput.profile["name"];

      let email = formatedOutput.profile["email"];
      let role = formatedOutput.profile["role"];
      if (document.getElementById("universal-header")) {
        window.CitySparkHeader.mountWidget("#universal-header", {
          activeTab:
            window.location.pathname.indexOf("photo-ballot") >= 0
              ? "Photos"
              : "Best",
          userName: name,
          userEmail: email,
          userRole: role,
          userInitials: name
            ? name
                .split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase()
            : "",
          organizationName: Cookies.get("customer_name") || "CitySpark",
          changelogUrl: "",
          shortcutsUrl: "",
          profileUrl: "",
          logoutUrl: "/auth/logout",
          adminBaseUrl: "https://adminbeta.cityspark.com",
          bestOfBaseUrl: process.env.REACT_APP_FRONT_END_SERVER_URL,
          photosBaseUrl:
            process.env.REACT_APP_FRONT_END_SERVER_URL +
            "/photo-ballot/all-campaigns",
          accessEventsApp: true,
          accessBusinessesApp: true,
        });
        window.addEventListener("hamburger-clicked", function(event) {
          console.log("Hamburger clicked event received in Dashboard");
          disableNavBarAndTopBar();
        });
      }
    };

    script.onerror = () => {
      console.error("Failed to load header.umd.v1.0.23.js");
    };

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="universal-header" style={{ marginBottom: "70px" }}></div>;
}

export default CitySparkHeader;
